import { Stack, Grid, Typography } from '@mui/material'
import type { FC } from 'react'

interface ExpectedErrorProps {
  text: string
  subtext?: string
  imagePath: string
}

const ExpectedError: FC<ExpectedErrorProps> = ({ imagePath, text, subtext }) => (
  <Grid
    container
    direction="column"
    alignItems="center"
    justifyContent="center"
    sx={{ minHeight: '100vh' }}
  >
    <Grid item>
      <Stack alignItems="center" spacing={2}>
        <img src={imagePath} style={{ width: '280px' }} alt="" />
        <Typography variant="h5" fontWeight="bold">
          {text}
        </Typography>
        {subtext !== undefined && <Typography variant="body1">{subtext}</Typography>}
      </Stack>
    </Grid>
  </Grid>
)

export default ExpectedError
